import API_ENDPOINTS from '../../endpoints/apiEndpoints';
import apiClient from '../../apiClient';

// 파일 서비스 정의
const ImageService = {
  // 이미지 리소스 조회
  getImageResource: async (encrypted: string): Promise<string> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_image_resource(encrypted),
        {
          headers: {
            Accept: '*/*',
          },
          responseType: 'blob', // 응답을 Blob으로 설정
        }
      );

      // Blob URL 생성하여 반환
      return URL.createObjectURL(response.data);
    } catch (error) {
      console.error('이미지 리소스 조회 실패:', error);
      throw error;
    }
  },

  // 이미지 다운로드
  downloadImage: async (): Promise<Blob> => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.get_image_download(), {
        headers: {
          Accept: '*/*',
        },
        responseType: 'blob',
      });

      return response.data; // Blob 반환
    } catch (error) {
      console.error('이미지 다운로드 실패:', error);
      throw error;
    }
  },

  // 이미지 미리보기 + 다운로드
  previewAndDownloadImage: async (): Promise<string> => {
    try {
      const response = await apiClient.get(
        API_ENDPOINTS.get_image_preview_download(),
        {
          headers: {
            Accept: '*/*',
          },
          responseType: 'blob', // 응답을 Blob으로 설정
        }
      );

      // Blob URL 생성하여 반환
      return URL.createObjectURL(response.data);
    } catch (error) {
      console.error('이미지 미리보기 + 다운로드 실패:', error);
      throw error;
    }
  },
};

export default ImageService;
